{
  "id": "campaign-052",
  "name": "Mossy Pasture",
  "seed": "campaign:52",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "RRRRR.......",
    "RRRRR.......",
    "_____.......",
    "..#......~..",
    "....c..c~~~.",
    "....c..c.x..",
    "..,.c..c....",
    "fffff..fffff",
    "..,.........",
    "..y......y..",
    "............",
    "ffffffff..ff",
    "............",
    ".T..T..T..T.",
    "..u......u..",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 3,
      "y": 3
    },
    {
      "kind": "rabbit",
      "x": 11,
      "y": 4
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 15
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 9
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 5,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 5
    },
    {
      "kind": "rare",
      "x": 9,
      "y": 3
    },
    {
      "kind": "repair",
      "x": 7,
      "y": 2
    }
  ],
  "generatorVersion": 3,
  "level": 52,
  "biome": "farm",
  "par": {
    "reel": 6257,
    "push": 5461,
    "selfPropelled": 4884,
    "tractor": 4690,
    "zeroTurn": 3249,
    "fairway": 2399
  },
  "routeTries": {
    "par": {
      "reel": 3,
      "push": 16,
      "selfPropelled": 19,
      "tractor": 12,
      "zeroTurn": 17,
      "fairway": 18
    }
  }
}
